module.exports = __webpack_public_path__ + "img/ysbq.faf19fdf.png";